module.exports = __webpack_public_path__ + "img/barcode-pic-example.e4d0fb45.jpg";